import { render, staticRenderFns } from "./EmployeeCourse.vue?vue&type=template&id=245dc2a2&"
import script from "./EmployeeCourse.vue?vue&type=script&lang=js&"
export * from "./EmployeeCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports